import { render, staticRenderFns } from "./etiquetas-hoja-de-piso.vue?vue&type=template&id=58ac94a8&scoped=true&"
import script from "./etiquetas-hoja-de-piso.vue?vue&type=script&lang=ts&"
export * from "./etiquetas-hoja-de-piso.vue?vue&type=script&lang=ts&"
import style0 from "./etiquetas-hoja-de-piso.vue?vue&type=style&index=0&id=58ac94a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ac94a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VMenu,VProgressCircular,VRow,VSelect,VSpacer})
